import React, { PropTypes, Component } from 'react'
import { Link } from 'react-router'
import classes from './Breadcrumb.scss'

class Breadcrumb extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    pageCount: PropTypes.number.isRequired
  };

  _pageBreak = (condition) =>
    condition && <li><a className={classes.disabled}>...</a></li>

  _pageLink = (condition, pageNo, queryString) => {
    const { pathname, query: { page } } = this.props.location
    return condition && (
      <li key={pageNo} className={pageNo === (parseInt(page, 10) || 1) ? classes.active : ''}>
        <Link to={`${pathname}?page=${pageNo}${queryString}`}>{pageNo}</Link>
      </li>
    )
  }

  render () {
    const { location, pageCount } = this.props
    const { pathname, query: { page, ...rest } } = location
    const currentPage = parseInt(page || 1, 10)
    const queryString = Object.keys(rest)
      .reduce((string, key) => `${string}&${key}=${rest[key]}`, '')

    return pageCount > 0 ? (
      <div className={classes.breadcrumb}>
        <div className={classes.arrow}>
          {currentPage > 1 && (
            <Link to={`${pathname}?page=${currentPage - 1}${queryString}`}>
              <img className={classes.arrow} src='/images/icon-arrow-left.png' alt='icon-arrow-left' />
            </Link>
          )}
        </div>
        {pageCount > 10 ? (
          <ul>
            {this._pageLink(pageCount > 1, 1, queryString)}
            {this._pageBreak(pageCount - currentPage < 2)}
            {this._pageBreak(pageCount - currentPage < 3)}
            {this._pageBreak(currentPage > 2)}
            {this._pageLink(currentPage === pageCount && currentPage > 2 && pageCount > 3, currentPage - 2, queryString)}
            {this._pageLink(currentPage > 2, currentPage - 1, queryString)}
            {this._pageLink(currentPage !== 1 && currentPage !== pageCount, currentPage, queryString)}
            {this._pageLink(currentPage < pageCount - 1, currentPage + 1, queryString)}
            {this._pageLink(currentPage < pageCount - 1 && currentPage === 1 && pageCount > 3, currentPage + 2, queryString)}
            {this._pageBreak(currentPage < pageCount - 3 && currentPage < 3)}
            {this._pageBreak(currentPage < pageCount - 2 && currentPage < 2)}
            {this._pageBreak(currentPage < pageCount - 2)}
            {this._pageLink(true, pageCount, queryString)}
          </ul>
        ) : (
          <ul>{[...Array(pageCount).keys()].map(key => this._pageLink(true, key + 1, queryString))}</ul>
        )}
        <div className={classes.arrow}>
          {currentPage < pageCount && (
            <Link to={`${pathname}?page=${currentPage + 1}${queryString}`}>
              <img className={classes.arrow} src='/images/icon-arrow-right.png' alt='icon-arrow-right' />
            </Link>
          )}
        </div>
      </div>
    ) : (
      <div className={classes.breadcrumb}>
        <ul>{this._pageLink(true, 1, queryString)}</ul>
      </div>
    )
  }
}

export default Breadcrumb



/** WEBPACK FOOTER **
 ** ./src/components/Breadcrumb.js
 **/